import { render, staticRenderFns } from "./data.vue?vue&type=template&id=23035a02&scoped=true"
import script from "./data.vue?vue&type=script&lang=ts"
export * from "./data.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23035a02",
  null
  
)

export default component.exports